export default __webpack_public_path__ + "static/media/tutoriel.3ae55dfc.jpeg";